/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownCourseResultScale } from '../models/db_DropdownCourseResultScale';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CourseResultScales {
    /**
     * Get a list of course result scales
     * @returns db_DropdownCourseResultScale OK
     * @throws ApiError
     */
    public static listCourseResultScales(): CancelablePromise<Array<db_DropdownCourseResultScale>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/course-result-scales',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
